import React, { useState, useEffect,useContext } from 'react'
import style from '../../../styles/mystyle.module.css'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'next-i18next'
import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import CardMedia from '@mui/material/CardMedia'
import IconButton from '@mui/material/IconButton'
import Checkbox from '@mui/material/Checkbox'
import * as config from '../../../next.config.js'
import { constants } from '../../../constants'
import Link from 'next/link'
import { useRouter } from "next/router";
import getOffers from '../../helpers/offers'
// import { styled } from "@mui/system"
import { useCart } from "../../../context/cart/use-cart";
import {getCookieValue} from '../../helpers/helpers'
import AddIcon from "@mui/icons-material/Add"
import MinusIcon from "@mui/icons-material/Remove"
import CurrencyContext from '../../../context/currencyProvider'
import OtherUnitsPrice from "./OtherUnitsPrice"
import QuantityDialog from "../Dialogs/QuantityDialog"
import { CustomeCard , CustomeCardMedia ,
   CustomeCardActions , CustomeCardContent ,
    CustomeIconbtn , CustomeCheckbox} from "./Product.style"



function OfferProducts({ data,exchangeCurrenciesRes,currencies}) {
  const [productItem, setProductItem] = useState({...data})
  const { t } = useTranslation("common");
  const currency= useContext(CurrencyContext)
  const { locale } = useRouter();
 const router=useRouter()
  useEffect(() => {
    
    if (data) {
     
      setProductItem(data)
    }

  }, [locale,data])
  const handleClose = () => {
    setOpenDailog(false);
  };
  const { addItem, removeItem, isInCart, getItem} = useCart();
  const [OpenDailog,setOpenDailog]=useState(false)
  const [DataQuantityDialog,setDataQuantityDialog]=useState({open:false,entityDetailsId:null,productUnitPriceId:null,productId:null,quantity:null})

  return (
    <>
      {

        productItem ?
          <div>
            {DataQuantityDialog.open?
        <QuantityDialog open={DataQuantityDialog.open}
        productId={DataQuantityDialog.productId}
        productUnitPriceId={DataQuantityDialog.productUnitPriceId}
        entityDetailsId={DataQuantityDialog.entityDetailsId}
        quantity={DataQuantityDialog.quantity}
                btnOk={() => {
                
                  setDataQuantityDialog({
                    open: false
                }) 
                }} 
                btnCancel={() => {
                
                  setDataQuantityDialog({
                    open: false
                })   
                }}
              />:""}
             {OpenDailog?
      <OtherUnitsPrice data={productItem}  onClose={handleClose} productUnitPriceList={productItem.OtherUnitsPrice} open={OpenDailog} currency={currency}/>:""}
            <div className={style.allcard + " "}>
              <CustomeCard>
                <Link className={style.AtagIcon + " " + style.hoverLink + " " + style.ColorBlack}
                  href={`/${constants.productUrl}/${productItem.slug.length > 0 && productItem.slug.filter(ele => ele.language.code == locale).length > 0 ? productItem.slug.filter(ele => ele.language.code == locale)[0].url : productItem.id}/${productItem.productUnitPrice && productItem.productUnitPrice[0].id}`} passHref >
                  <CustomeCardMedia
                    component="img"
                    sx={{ 1000: { height: "380", width: "380" }, 400: { height: "350", width: "350" } }}
                    image={
                      productItem.productImages.length > 0 && productItem.productImages[0].image != "" && productItem.productImages[0].image != null ?
                        productItem.productImages[0].image
                        :
                        `${config.basePath}/assest/logo.svg`
                    }
                    alt="image"
                  />
                </Link>
                <CustomeCardContent>
                  <Link className={style.AtagIcon + " " + style.hoverLink + " " + style.ColorBlack}
                    href={`/${constants.productUrl}/${productItem.slug.length > 0 && productItem.slug.filter(ele => ele.language.code == locale).length > 0 ? productItem.slug.filter(ele => ele.language.code == locale)[0].url : productItem.id}/${productItem.productUnitPrice && productItem.productUnitPrice[0].id}`} passHref >
                    <Typography fontWeight="600" gutterBottom variant="h5" component="div" marginBottom="0">
                     
                      {productItem.transProduct[0].name.length > 20 ? productItem.transProduct[0].name.substr(0, 20) + "... " : productItem.transProduct[0].name}
                      {" "} {productItem.productUnitPrice  && productItem.productUnitPrice.length&&  productItem.productUnitPrice[0].unit &&  productItem.productUnitPrice[0].unit.length>0 && productItem.productUnitPrice[0].unit.filter(i=>i.language.code==locale).length>0? `(${ productItem.productUnitPrice[0].unit &&productItem.productUnitPrice[0].unit.filter(i=>i.language.code==locale)[0].name })`:""} 

                    </Typography></Link>
                  <Typography gutterBottom variant="h5" component="div">
                    {productItem.productUnitPrice && productItem.productUnitPrice.length && productItem.productUnitPrice[0].entityDetails&& productItem.productUnitPrice[0].entityDetails.length > 0 ? productItem.productUnitPrice[0].entityDetails[0].transEntityDetails[0].officialName.length > 20 ? productItem.productUnitPrice[0].entityDetails[0].transEntityDetails[0].officialName.substr(0, 20) + "... " :
                      productItem.productUnitPrice[0].entityDetails[0].transEntityDetails[0].officialName : ""}
                  </Typography>
                </CustomeCardContent>
      
                <CustomeCardActions>
                  {(() => {
 
    if (productItem.productUnitPrice && productItem.productUnitPrice .length>0 && productItem.productUnitPrice[0].productOffer &&productItem.productUnitPrice[0].productOffer.length) {
          return <>
                        <div className={style.DisCountSquare}>
                          <div className={style.SquareOffer}>{t("offer")}</div>
                        </div>
                      </>
                    }
                  })()}
                  <div className={style.markandheartproduct}>
                    <img className={style.markproduct} src={`${config.basePath}/assest/Myfav.svg`} ></img>
                    <CustomeCheckbox
                      icon={<img className={style.StarBorderDiet + " " + style.heartproduct}
                        src={`${config.basePath}/assest/OutlineStar.svg`} ></img>
                      }
                      checked={getItem(productItem.productUnitPrice[0].id, null, productItem.productUnitPrice[0].entityDetailsId, getCookieValue("userCountry")) != null && getItem(productItem.productUnitPrice[0].id, null, productItem.productUnitPrice[0].entityDetailsId, getCookieValue("userCountry")).isFavoriate == true}
                      checkedIcon={<img className={style.StarDiet + " " + style.heartproduct}
                        src={`${config.basePath}/assest/Fullstar.svg`} ></img>
                      }
                      className={style.heartproduct}
                      onClick={(e) => {
                        if (e.target.checked == true) {
                          addItem({
                            type: "products",
                            entityId:productItem.productUnitPrice[0].id,
                            isFavoriate: true,
                            quantity: 0,
                            productUnitPrice: null,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        } else if (e.target.checked == false) {
                          removeItem({
                            type: "products",
                            entityId: productItem.productUnitPrice[0].id,
                            isFavoriate: false,
                            quantity: 0,
                            productUnitPrice: null,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")

                          })
                        }

                      }}
                    /></div>

                  <div className={style.TwotextpriceProduct + " " + style.paddingTextProduct}>


                    {(() => {
                      if (productItem.productUnitPrice && productItem.productUnitPrice.length > 0 && productItem.productUnitPrice[0].displayPrice == true) {
                        let hasOffer = false
                        let prodOffer = null
                        let offerCurrency = null
                        let Precentage = 0
                        let getExchangeCurrency=currency.exchangeCurrencyRes&&currency.exchangeCurrencyRes.filter(ele=>ele.from==productItem.productUnitPrice[0].currency[0].id && ele.to==currency.currency)
                        if(getExchangeCurrency&&getExchangeCurrency.length>0){
                          getExchangeCurrency=getExchangeCurrency[0].exchangedAmount
                        }
                        else{
                          getExchangeCurrency=currency.exchangeCurrencyRes&&currency.exchangeCurrencyRes.length>0?currency.exchangeCurrencyRes.filter(ele=>ele.from==productItem.productUnitPrice[0].currency[0].id)[0].exchangedAmount:1
                        }
                      
                        if(currency.currenciesLst.filter(ele=>ele.id==currency.currency).length>0){
                          offerCurrency= currency.currenciesLst.filter(ele=>ele.id==currency.currency)[0].transCurrency.filter(ele=>ele.language.code==locale)[0].currencySymbol
                        }
                        else{
                          offerCurrency=currency.currenciesLst.filter(ele=>ele.local==true)[0].transCurrency.filter(ele=>ele.language.code==locale)[0].currencySymbol
                        }
                        let Price = (productItem.productUnitPrice[0].price*getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })
                        if (productItem.productUnitPrice && productItem.productUnitPrice .length>0 && productItem.productUnitPrice[0].productOffer &&productItem.productUnitPrice[0].productOffer.length) {
                          Precentage = ((productItem.productUnitPrice[0].productOffer[0].fixedPrecentage) + (productItem.productUnitPrice[0].productOffer[0].fixedAmount / productItem.productUnitPrice[0].price) * 100)
                          hasOffer = true
                          prodOffer = getOffers(
                            productItem.productUnitPrice[0].productOffer[0].fixedPrecentage,
                            productItem.productUnitPrice[0].price,
                            productItem.productUnitPrice[0].productOffer[0].fixedAmount
                          )
                        }
                        return <>
                          {hasOffer ? <p className={style.textPriceProduct}>
                            {(prodOffer)*getExchangeCurrency.toLocaleString('en-US', { minimumFractionDigits: 2 })} {""}
                            {offerCurrency}
                          </p> : ""}
                          {prodOffer == productItem.productUnitPrice[0].price ? "" :
                            <div className={style.flex + " " + style.halfGap}>
                              <p className={style.textPriceProduct}
                                style={{ textDecoration: hasOffer ? "line-through" : "none", textDecorationColor: hasOffer ? "red" : "none" }}
                              >
                                {Price}
                                {" "}
                                  {offerCurrency}
                              </p>
                              {Precentage > 0 ?
                                <div className={style.DisSquareOffer + " " + style.widthOffer}>{(Precentage.toFixed(2)) + "-" + " %"}</div>
                                : ""}
                            </div>
                          }
                        </>
                      } else{
                        return  <p className={style.textPriceProduct}>
                      {t("priceHiddin")}
                      </p> 
                      }
                    })()}
                  </div>
                  <br />
                  <div className={style.AddCart}  >
                  {(()=>{

                 
                    if(productItem.productUnitPrice.length>0&&productItem.productUnitPrice[0].ProductUnitPriceFeatures&&productItem.productUnitPrice[0].ProductUnitPriceFeatures.length>0){
                     
                      return  <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                      onClick={() =>{
                        setOpenDailog(true)
                        
                      }}
                        
                        >   { <><AddIcon/> {t("add")}</> } </button>

                    }
                    else if(productItem.OtherUnitsPrice&&productItem.OtherUnitsPrice.length>0){
                      return <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                      onClick={() =>{
                       router.push(`/${constants.productUrl}/${productItem.slug.length > 0 && productItem.slug.filter(ele => ele.language.code == locale).length > 0 ? productItem.slug.filter(ele => ele.language.code == locale)[0].url : productItem.id}/${productItem.productUnitPrice && productItem.productUnitPrice[0].id}/other-prices`)
                      }}

                        
                        >   { <><AddIcon/> {t("showOptions")}</> } </button>

                    }
                    else{
                      if(isInCart(
                        productItem.id,
                        "products",
                        productItem.productUnitPrice[0].id,
                        productItem.productUnitPrice[0].entityDetailsId,
                        getCookieValue("userCountry") 
                      )){
                        return<div className={style.DivCount + " " + style.fullwidth  + " " + style.borderteal+ " " + style.borderRadius}>
                        <div><CustomeIconbtn className={style.Count + " " + style.paddingZero} onClick={e =>
                          addItem({
                            type: "products",
                            entityId: productItem.id,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPrice[0].id,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }><div className={  style.bordercount +" "+style.FlexPM}><AddIcon/></div></CustomeIconbtn></div>
                        <button  className={style.Count + " " + style.borderRadius} onClick={e=>{setDataQuantityDialog({productId:productItem.id,productUnitPriceId:productItem.productUnitPrice[0].id,entityDetailsId:productItem.productUnitPrice[0].entityDetailsId,open:true,quantity:getItem(productItem.id, productItem.productUnitPrice[0].id,productItem.productUnitPrice[0].entityDetailsId, getCookieValue("userCountry")) != null ? getItem( productItem.id,  productItem.productUnitPrice[0].id, productItem.productUnitPrice[0].entityDetailsId, getCookieValue("userCountry")).quantity:null})}}>
                        <p style={{ marginBottom: 0, fontWeight: 600 }}>{getItem(
                          productItem.id,
                          productItem.productUnitPrice[0].id,
                          productItem.productUnitPrice[0].entityDetailsId,
                          getCookieValue("userCountry")
                        ) != null
                          ? getItem(
                            productItem.id,
                            productItem.productUnitPrice[0].id,
                            productItem.productUnitPrice[0].entityDetailsId,
                            getCookieValue("userCountry")
                          ).quantity
                          : ""}</p></button>
                        <div><CustomeIconbtn className={style.Count + " " + style.paddingZero} onClick={e =>
                          removeItem({
                            type: "products",
                            entityId: productItem.id,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPrice[0].id,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }><div className={  style.bordercount +" "+style.FlexPM}><MinusIcon/></div></CustomeIconbtn></div>
                      </div>
                      }
                      else{
                        return <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                        onClick={() =>{
                      
                          addItem({
                            type: "products",
                            entityId: productItem.id,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPrice[0].id,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }}
                          
                          >   { <><AddIcon/> {t("add")}</> } </button>
                      }

                    
              
                    }
                  })()}
                    {/* {isInCart(
                      productItem.id,
                      "products",
                      productItem.productUnitPrice[0].id,
                      productItem.productUnitPrice[0].entityDetailsId,
                      getCookieValue("userCountry") 
                    )&& !(productItem.OtherUnitsPrice &&productItem.OtherUnitsPrice.length>0) ?
                      <div className={style.DivCount + " " + style.fullwidth  + " " + style.borderteal+ " " + style.borderRadius}>
                        <div><CustomeIconbtn className={style.Count + " " + style.paddingZero} onClick={e =>
                          addItem({
                            type: "products",
                            entityId: productItem.id,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPrice[0].id,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }><div className={  style.bordercount +" "+style.FlexPM}><AddIcon/></div></CustomeIconbtn></div>
                        <button  className={style.Count + " " + style.borderRadius} onClick={e=>{setDataQuantityDialog({productId:productItem.id,productUnitPriceId:productItem.productUnitPrice[0].id,entityDetailsId:productItem.productUnitPrice[0].entityDetailsId,open:true,quantity:getItem(productItem.id, productItem.productUnitPrice[0].id,productItem.productUnitPrice[0].entityDetailsId, getCookieValue("userCountry")) != null ? getItem( productItem.id,  productItem.productUnitPrice[0].id, productItem.productUnitPrice[0].entityDetailsId, getCookieValue("userCountry")).quantity:null})}}>
                        <p style={{ marginBottom: 0, fontWeight: 600 }}>{getItem(
                          productItem.id,
                          productItem.productUnitPrice[0].id,
                          productItem.productUnitPrice[0].entityDetailsId,
                          getCookieValue("userCountry")
                        ) != null
                          ? getItem(
                            productItem.id,
                            productItem.productUnitPrice[0].id,
                            productItem.productUnitPrice[0].entityDetailsId,
                            getCookieValue("userCountry")
                          ).quantity
                          : ""}</p></button>
                        <div><CustomeIconbtn className={style.Count + " " + style.paddingZero} onClick={e =>
                          removeItem({
                            type: "products",
                            entityId: productItem.id,
                            isFavoriate: false,
                            quantity: 1,
                            productUnitPrice: productItem.productUnitPrice[0].id,
                            entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                            userCountry: getCookieValue("userCountry")
                          })
                        }><div className={  style.bordercount +" "+style.FlexPM}><MinusIcon/></div></CustomeIconbtn></div>
                      </div>
                      : <button className={style.btnAdd + " " + style.fullwidth + " " + style.paddingAddCartPro + " " + style.borderRadius}
                      onClick={() =>{
                    
                        if(productItem.OtherUnitsPrice &&productItem.OtherUnitsPrice.length>0||(productItem.productUnitPrice[0].ProductUnitPriceFeatures && productItem.productUnitPrice[0].ProductUnitPriceFeatures.length>0)){

                          setOpenDailog(true)
                         }else{
                        addItem({
                          type: "products",
                          entityId: productItem.id,
                          isFavoriate: false,
                          quantity: 1,
                          productUnitPrice: productItem.productUnitPrice[0].id,
                          entityDetailsId: productItem.productUnitPrice[0].entityDetailsId,
                          userCountry: getCookieValue("userCountry")
                        })}
                      }}
                        
                        >   {productItem.OtherUnitsPrice &&productItem.OtherUnitsPrice.length>0?t("showOptions"): <><AddIcon/> {t("add")}</> } </button>} */}
                  </div>
                </CustomeCardActions>
              </CustomeCard>
            </div></div>
          : ""
      }

    </>

  )
}

export default OfferProducts


